import React, { FC } from 'react';
import styled from 'styled-components';

import { Course, Player, Match, PlayerResult, TeamGameMatch } from '../../../../../database.schema';

const CourseWrapper = styled.h3`
  margin: 1rem 0;
`;
const MessageWrapper = styled.div`
  margin: 1rem 0;
`;
const Table = styled.table`
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  color: white;
  background: gray;
`;

const TableHeader = styled.th`
  text-align: center;
  font-weight: bold;
  color: black;
  background: white;
  font-size: 1rem;
  font-size: 1.25rem;
  font-weight: bold;
`;

const TableCell = styled.td`
  text-align: center;
  padding: 0.5rem 0;
`;

export const TableRowBorder = styled.tr<{ colour?: string | null }>`
  margin-bottom: 5px;
  background: white;
  margin-bottom: 5px;
  color: ${(props) => props.colour || 'black'};
  font-size: 1.2rem;
  font-weight: bold;
`;

type HandicConfirmProps = {
  recordedMatch: TeamGameMatch;
  course: Course;
  players: Array<Player>;
  teamIndex: number;
};

export const TeamGameHandicapEntryConfirmation: FC<HandicConfirmProps> = ({ recordedMatch, course, players, teamIndex }): JSX.Element => {
  return (
    <div>
      <h2>Confirm Handicaps</h2>
      <CourseWrapper>Course: {course.name}</CourseWrapper>
      <Table>
        <thead>
          <tr>
            <TableHeader>Player</TableHeader>
            <TableHeader>Handicap</TableHeader>
            <TableHeader>Stableford</TableHeader>
          </tr>
        </thead>
        <tbody>
          {recordedMatch.teams[teamIndex].players.map((player: PlayerResult) => (
            <TableRowBorder colour="red" key={`hcaps-t1-${player.playerId}`}>
              <TableCell>{players.find((playerA: Player) => playerA.id === player.playerId)?.nickName}</TableCell>
              <TableCell>{player.round.courseHandicap}</TableCell>
              <TableCell>{player.round.individualHandicap}</TableCell>
            </TableRowBorder>
          ))}
        </tbody>
      </Table>
      <MessageWrapper>
        <div>Stableford 95% of handicap</div>
      </MessageWrapper>
    </div>
  );
};
